var urlPath = 'services/video-maker';
export var getBaseUrl = function () {
    return typeof location !== 'undefined' && location.host.endsWith('editorx.com')
        ? "https://pix.editorx.com/".concat(urlPath)
        : "https://pix.wix.com/".concat(urlPath);
};
//# sourceMappingURL=getBaseUrl.js.map